import { lazy } from 'react';

export enum AdvisorWidgetCodes {
  InsightsOverview = 'advisor-insights-overview',
  ClientActivity = 'advisor-client-activity',
  ClientsGrid = 'advisor-clients-grid',
  CashflowPage = 'advisor-cashflow-page',
  GainlossPage = 'advisor-gainloss-page',
  PersonalFinancialStatementPage = 'advisor-personal-financial-statement-page',
  AccountsPage = 'advisor-accounts-grid',
  TopHoldings = 'advisor-holdings-grid',
  ClientHoldingsTab = 'advisor-client-holdings-tab',
  AssetAllocationPage = 'advisor-asset-allocation-chart',
  InvestmentActivity = 'advisor-investment-activity',
  DocumentVault = 'advisor-document-vault-page',
  BalanceSheetGrid = 'advisor-balancesheet-grid',
  NetWorthChanges = 'advisor-daily-changes',
  QuickLinks = 'advisor-quick-links',
  WealthReportedTrend = 'advisor-historical-aum',
  HistoricalDiversification = 'advisor-pd-historical',
  Resources = 'advisor-resources',
  PortfolioDiversification = 'advisor-diversification',
}

const advisorWidgetMap = {
  [AdvisorWidgetCodes.InsightsOverview]: lazy(
    async () => import('@/widgets/advisor/RecentInsightsWidget'),
  ),
  [AdvisorWidgetCodes.ClientActivity]: lazy(
    async () => import('@/widgets/advisor/ClientActivityWidget'),
  ),
  [AdvisorWidgetCodes.ClientsGrid]: lazy(
    async () => import('@/modules/advisor/dashboard/DashboardClientsGrid'),
  ),
  [AdvisorWidgetCodes.CashflowPage]: lazy(
    async () => import('@/pages/cashFlow'),
  ),
  [AdvisorWidgetCodes.GainlossPage]: lazy(
    async () => import('@/modules/portfolio/gainLoss/GainLoss'),
  ),
  [AdvisorWidgetCodes.PersonalFinancialStatementPage]: lazy(
    async () => import('@/widgets/investor/PersonalFinancialStatement'),
  ),
  [AdvisorWidgetCodes.AccountsPage]: lazy(
    async () => import('@/components/grids/AccountsGrid'),
  ),
  [AdvisorWidgetCodes.TopHoldings]: lazy(
    async () =>
      import('@/modules/advisor/dashboard/DashboardTopHoldingsWidget'),
  ),
  [AdvisorWidgetCodes.ClientHoldingsTab]: lazy(
    async () => import('@/modules/portfolio/tables/holdingsTable'),
  ),
  [AdvisorWidgetCodes.AssetAllocationPage]: lazy(
    async () => import('@/modules/portfolio/charts/assetAllocationPieChart'),
  ),
  [AdvisorWidgetCodes.InvestmentActivity]: lazy(
    async () => import('@/widgets/investor/InvestmentActivity'),
  ),
  [AdvisorWidgetCodes.DocumentVault]: lazy(
    async () => import('@/pages/document/documentVault'),
  ),
  [AdvisorWidgetCodes.BalanceSheetGrid]: lazy(
    async () => import('@/widgets/advisor/BalanceSheetWidget'),
  ),
  [AdvisorWidgetCodes.NetWorthChanges]: lazy(
    async () =>
      import('@/modules/advisor/netWorthChanges/BiggestNetWorthChangesWidget'),
  ),
  [AdvisorWidgetCodes.QuickLinks]: lazy(
    async () => import('@/modules/advisor/components/AdvisorQuickLinksWidget'),
  ),
  [AdvisorWidgetCodes.WealthReportedTrend]: lazy(
    async () =>
      import('@/modules/advisor/wealthTrend/WealthReportedTrendWidget'),
  ),
  [AdvisorWidgetCodes.HistoricalDiversification]: lazy(
    async () =>
      import('@/modules/advisor/dashboard/DashboardHistoricalDiversificationWidget'),
  ),
  [AdvisorWidgetCodes.Resources]: lazy(
    async () => import('@/modules/advisor/components/AdvisorResourcesWidget'),
  ),
  [AdvisorWidgetCodes.PortfolioDiversification]: lazy(
    async () =>
      import('@/modules/advisor/dashboard/DashboardPortfolioDiversificationWidget'),
  ),
};

export default advisorWidgetMap;
